import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hide-menu",
  "use": "hide-menu-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"hide-menu\"><path d=\"M0 16h17M7 11h10M7 6h10M0 1h17M3.25 10.484L.795 8.5 3.25 6.516v3.968z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol